/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteCallSessionsByIdsRequest
 */
export interface DeleteCallSessionsByIdsRequest {
    /**
     * 
     * @type {number}
     * @memberof DeleteCallSessionsByIdsRequest
     */
    campaignId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof DeleteCallSessionsByIdsRequest
     */
    callSessionIds: Array<number>;
}

/**
 * Check if a given object implements the DeleteCallSessionsByIdsRequest interface.
 */
export function instanceOfDeleteCallSessionsByIdsRequest(value: object): value is DeleteCallSessionsByIdsRequest {
    if (!('campaignId' in value) || value['campaignId'] === undefined) return false;
    if (!('callSessionIds' in value) || value['callSessionIds'] === undefined) return false;
    return true;
}

export function DeleteCallSessionsByIdsRequestFromJSON(json: any): DeleteCallSessionsByIdsRequest {
    return DeleteCallSessionsByIdsRequestFromJSONTyped(json, false);
}

export function DeleteCallSessionsByIdsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteCallSessionsByIdsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'campaignId': json['campaignId'],
        'callSessionIds': json['callSessionIds'],
    };
}

export function DeleteCallSessionsByIdsRequestToJSON(json: any): DeleteCallSessionsByIdsRequest {
    return DeleteCallSessionsByIdsRequestToJSONTyped(json, false);
}

export function DeleteCallSessionsByIdsRequestToJSONTyped(value?: DeleteCallSessionsByIdsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'campaignId': value['campaignId'],
        'callSessionIds': value['callSessionIds'],
    };
}

